import useSettings from '@/hooks/useSettings';
import SettingsDialog from './SettingsDialog';
import { toTimeString } from './SettingsForm/timeStrings';

function Settings() {
  const { duration, rest, repeats } = useSettings();

  return (
    <div className="flex gap-2 align-top justify-between hidden-low">
      <p>
        Go for&ensp;
        <span className="font-mono">{toTimeString(duration)}</span>
        , rest&ensp;
        <span className="font-mono">{toTimeString(rest)}</span>
        <br />
        {repeats === 0 ? 'Repeat until stopped' : `Repeat ${repeats} times.`}
      </p>
      <SettingsDialog />
    </div>
  );
}

export default Settings;
